import { Container } from './styles/page.style';
import img404 from '../../assets/images/404-primee.png'

const PageNotFound = () => {

  return (
    <Container>
      <div className='d-flex justify-content-center my-5'>
        <img src={img404} />
      </div>
      <div className='d-flex justify-content-center'>
        <div className='text-center'>
          <h5>Página não encontrada!</h5>
          <small><strong>A página que você está procurando não existe.</strong></small>
        </div>
      </div>
    </Container>
  )
}

export default PageNotFound;